var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "afterSaleDetail" },
    [
      _c(
        "el-form",
        {
          ref: "afterSaleDetailForm",
          staticClass: "demo-form-inline",
          staticStyle: { "margin-bottom": "10px" },
          attrs: {
            "label-position": "left",
            inline: true,
            model: _vm.afterSaleDetailForm
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "日期" } },
            [
              _c(
                "el-col",
                { attrs: { span: 11 } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "date",
                      placeholder: "开始日期",
                      format: "yyyy-MM-dd",
                      "value-format": "yyyy-MM-dd"
                    },
                    model: {
                      value: _vm.afterSaleDetailForm.start_time,
                      callback: function($$v) {
                        _vm.$set(_vm.afterSaleDetailForm, "start_time", $$v)
                      },
                      expression: "afterSaleDetailForm.start_time"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("el-col", { staticClass: "line", attrs: { span: 2 } }, [
                _vm._v("-")
              ]),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 11 } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "date",
                      placeholder: "结束日期",
                      format: "yyyy-MM-dd",
                      "value-format": "yyyy-MM-dd"
                    },
                    model: {
                      value: _vm.afterSaleDetailForm.end_time,
                      callback: function($$v) {
                        _vm.$set(_vm.afterSaleDetailForm, "end_time", $$v)
                      },
                      expression: "afterSaleDetailForm.end_time"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "服务编号" } },
            [
              _c("el-input", {
                attrs: { placeholder: "服务编号" },
                nativeOn: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.searchAftersaleList.apply(null, arguments)
                  }
                },
                model: {
                  value: _vm.afterSaleDetailForm.as_number,
                  callback: function($$v) {
                    _vm.$set(_vm.afterSaleDetailForm, "as_number", $$v)
                  },
                  expression: "afterSaleDetailForm.as_number"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "订单号" } },
            [
              _c("el-input", {
                attrs: { placeholder: "订单号" },
                nativeOn: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.searchAftersaleList.apply(null, arguments)
                  }
                },
                model: {
                  value: _vm.afterSaleDetailForm.order_number,
                  callback: function($$v) {
                    _vm.$set(_vm.afterSaleDetailForm, "order_number", $$v)
                  },
                  expression: "afterSaleDetailForm.order_number"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "锐锢编码" } },
            [
              _c("el-input", {
                attrs: { placeholder: "锐锢编码" },
                nativeOn: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.searchAftersaleList.apply(null, arguments)
                  }
                },
                model: {
                  value: _vm.afterSaleDetailForm.ruigu_code,
                  callback: function($$v) {
                    _vm.$set(_vm.afterSaleDetailForm, "ruigu_code", $$v)
                  },
                  expression: "afterSaleDetailForm.ruigu_code"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "售后类型" } },
            [
              _c(
                "el-select",
                {
                  attrs: { clearable: "", placeholder: "售后类型" },
                  model: {
                    value: _vm.afterSaleDetailForm.as_type,
                    callback: function($$v) {
                      _vm.$set(_vm.afterSaleDetailForm, "as_type", $$v)
                    },
                    expression: "afterSaleDetailForm.as_type"
                  }
                },
                _vm._l(_vm.typeList, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { value: item.value, label: item.label }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.showAfterSaleSeach
            ? _c(
                "el-form-item",
                { attrs: { label: "售后状态" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "200px" },
                      attrs: {
                        clearable: "",
                        placeholder: "售后状态",
                        multiple: _vm.isZhifaOrFactory ? true : false,
                        "collapse-tags": _vm.isZhifaOrFactory ? true : false
                      },
                      model: {
                        value: _vm.afterSaleDetailForm.as_status,
                        callback: function($$v) {
                          _vm.$set(_vm.afterSaleDetailForm, "as_status", $$v)
                        },
                        expression: "afterSaleDetailForm.as_status"
                      }
                    },
                    _vm._l(_vm.statusList, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { value: item.value, label: item.label }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "处理方式" } },
            [
              _c(
                "el-select",
                {
                  attrs: { clearable: "", placeholder: "处理方式" },
                  model: {
                    value: _vm.afterSaleDetailForm.as_status_source,
                    callback: function($$v) {
                      _vm.$set(_vm.afterSaleDetailForm, "as_status_source", $$v)
                    },
                    expression: "afterSaleDetailForm.as_status_source"
                  }
                },
                [
                  _c("el-option", { attrs: { value: 2, label: "客服处理" } }),
                  _vm._v(" "),
                  _c("el-option", { attrs: { value: 1, label: "店铺处理" } })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "快递单号" } },
            [
              _c("el-input", {
                attrs: { placeholder: "快递单号" },
                nativeOn: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.searchAftersaleList.apply(null, arguments)
                  }
                },
                model: {
                  value: _vm.afterSaleDetailForm.delivery_number,
                  callback: function($$v) {
                    _vm.$set(_vm.afterSaleDetailForm, "delivery_number", $$v)
                  },
                  expression: "afterSaleDetailForm.delivery_number"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "客户姓名/电话", "label-width": "90px" } },
            [
              _c("el-input", {
                attrs: { placeholder: "客户姓名或电话" },
                nativeOn: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.searchAftersaleList.apply(null, arguments)
                  }
                },
                model: {
                  value: _vm.afterSaleDetailForm.user_name,
                  callback: function($$v) {
                    _vm.$set(_vm.afterSaleDetailForm, "user_name", $$v)
                  },
                  expression: "afterSaleDetailForm.user_name"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "物流联系电话", "label-width": "85px" } },
            [
              _c("el-input", {
                nativeOn: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.searchAftersaleList.apply(null, arguments)
                  }
                },
                model: {
                  value: _vm.afterSaleDetailForm.courier_mobile,
                  callback: function($$v) {
                    _vm.$set(_vm.afterSaleDetailForm, "courier_mobile", $$v)
                  },
                  expression: "afterSaleDetailForm.courier_mobile"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.isZhifaOrFactory
            ? _c(
                "el-form-item",
                { attrs: { label: "提货物流状态", "label-width": "90px" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { clearable: "", placeholder: "请选择" },
                      model: {
                        value: _vm.afterSaleDetailForm.in_box_status,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.afterSaleDetailForm,
                            "in_box_status",
                            $$v
                          )
                        },
                        expression: "afterSaleDetailForm.in_box_status"
                      }
                    },
                    _vm._l(Object.keys(_vm.logStatusOptions), function(item) {
                      return _c("el-option", {
                        key: item,
                        attrs: {
                          label: _vm.logStatusOptions[item],
                          value: item
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isZhifaOrFactory
            ? _c(
                "el-form-item",
                { attrs: { label: "送货物流状态", "label-width": "90px" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { clearable: "", placeholder: "请选择" },
                      model: {
                        value: _vm.afterSaleDetailForm.out_box_status,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.afterSaleDetailForm,
                            "out_box_status",
                            $$v
                          )
                        },
                        expression: "afterSaleDetailForm.out_box_status"
                      }
                    },
                    _vm._l(Object.keys(_vm.logStatusOptions2), function(item) {
                      return _c("el-option", {
                        key: item,
                        attrs: {
                          label: _vm.logStatusOptions2[item],
                          value: item
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.searchAftersaleList }
                },
                [_vm._v("查询")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "boder-top" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "tableTitle" }, [
          _c(
            "div",
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.showPrintType,
                      expression: "!showPrintType"
                    }
                  ],
                  attrs: {
                    size: "small",
                    type: "primary",
                    disabled: _vm.receiveEnable
                  },
                  on: {
                    click: function($event) {
                      return _vm.saleConfirm("receive")
                    }
                  }
                },
                [_vm._v("售后收货")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    type: "primary",
                    disabled: _vm.confirmEnable
                  },
                  on: {
                    click: function($event) {
                      return _vm.saleConfirm("accept")
                    }
                  }
                },
                [_vm._v("售后确认")]
              ),
              _vm._v(" "),
              _vm.shopIds.indexOf(_vm.shop_id) < 0
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        size: "small",
                        type: "primary",
                        disabled: _vm.outEnable
                      },
                      on: {
                        click: function($event) {
                          return _vm.saleConfirm("return")
                        }
                      }
                    },
                    [_vm._v("售后出库")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showLabel,
                      expression: "showLabel"
                    }
                  ],
                  attrs: {
                    size: "small",
                    type: "primary",
                    disabled: _vm.labelEnable
                  },
                  on: { click: _vm.printAftersale }
                },
                [_vm._v("打印售后标签")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    type: "primary",
                    disabled: _vm.sheetEnable
                  },
                  on: { click: _vm.printShippingList }
                },
                [_vm._v("打印售后发货单")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.inputTs }
                },
                [_vm._v("录入物流运单")]
              )
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("after-sale-table", {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loadingAftersale,
            expression: "loadingAftersale"
          }
        ],
        ref: "afterSaleTable",
        staticClass: "after-sale",
        attrs: { data: _vm.aftersaleTableData, statusActive: _vm.statusActive },
        on: {
          getSelectSaleData: _vm.getSelectSaleData,
          getTrackNo: _vm.getTrackNo,
          getBoxData: _vm.getBoxData,
          changeBoxData: _vm.changeBoxData
        }
      }),
      _vm._v(" "),
      _vm.showPagination
        ? _c("el-pagination", {
            attrs: {
              "current-page": _vm.currentPage,
              "page-sizes": [10, 50, 100, 200],
              "page-size": _vm.pagesize,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.totalCount
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-tabs",
        {
          attrs: { type: "card" },
          model: {
            value: _vm.activeName,
            callback: function($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName"
          }
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "商品信息", name: "goods_info" } },
            [
              _c("after-sale-detail-table", {
                attrs: {
                  data: _vm.aftersaleDetailTableData,
                  type: _vm.aftersaleDetailType
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.isZhifaOrFactory
            ? _c(
                "el-tab-pane",
                { attrs: { label: "提货物流轨迹", name: "log_track_take" } },
                [
                  _c("orderTrack", {
                    attrs: { type: 1, as_number: _vm.current_row_as_number }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isZhifaOrFactory
            ? _c(
                "el-tab-pane",
                {
                  attrs: { label: "送货物流轨迹", name: "log_track_delivery" }
                },
                [
                  _c("orderTrack", {
                    attrs: { type: 2, as_number: _vm.current_row_as_number }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("after-sale-edit-dialog", { ref: "afterSaleEditDialog" }),
      _vm._v(" "),
      _c("close-reason-dialog", {
        ref: "closeReasonDialog",
        on: { refreshData: _vm.getAftersaleList }
      }),
      _vm._v(" "),
      _c("order-dialog", {
        ref: "orderDialog",
        attrs: { boxData: _vm.boxData }
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.boxDetailDialog,
            "append-to-body": true,
            width: "500px"
          },
          on: {
            "update:visible": function($event) {
              _vm.boxDetailDialog = $event
            }
          }
        },
        [
          _c(
            "span",
            {
              style: { color: "#fff" },
              attrs: { slot: "title" },
              slot: "title"
            },
            [_vm._v("服务编号：" + _vm._s(_vm.rowData.as_number))]
          ),
          _vm._v(" "),
          _vm.boxDetailDialog
            ? _c("waybillDetial", { attrs: { row: _vm.rowData } })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("boxcode", {
        directives: [
          { name: "show", rawName: "v-show", value: false, expression: "false" }
        ],
        ref: "aftersaleboxcode"
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "创建工单",
            "append-to-body": "",
            center: "",
            visible: _vm.isShowAdd,
            top: "250px",
            width: "600px"
          },
          on: {
            "update:visible": function($event) {
              _vm.isShowAdd = $event
            },
            close: _vm.closeAdd
          }
        },
        [
          _c("div", { staticClass: "exportbtnbox" }, [
            _c(
              "div",
              { staticClass: "box1" },
              [
                _c("i", [_vm._v("*")]),
                _c("span", { staticStyle: { width: "65px" } }, [
                  _vm._v("来源单号")
                ]),
                _vm._v(" "),
                _c("el-input", {
                  attrs: {
                    type: "textarea",
                    autosize: "",
                    resize: "none",
                    placeholder: "请输入",
                    disabled: true
                  },
                  model: {
                    value: _vm.build.businessKey,
                    callback: function($$v) {
                      _vm.$set(_vm.build, "businessKey", $$v)
                    },
                    expression: "build.businessKey"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "box2" }, [
              _c("i", [_vm._v("*")]),
              _c("span", [_vm._v("问题类型")]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("el-cascader", {
                    staticClass: "cascader",
                    attrs: {
                      options: _vm.options,
                      clearable: "",
                      filterable: "",
                      placeholder: "请选择问题类型"
                    },
                    on: { change: _vm.handleChange },
                    model: {
                      value: _vm.build.problemTypes,
                      callback: function($$v) {
                        _vm.$set(_vm.build, "problemTypes", $$v)
                      },
                      expression: "build.problemTypes"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-tooltip", { attrs: { placement: "top" } }, [
                    _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                      _c("div", [_vm._v(_vm._s(_vm.descPrompt))])
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "el-icon-question pointer" })
                  ])
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "box1 box-descript" },
              [
                _c("i", [_vm._v("*")]),
                _c(
                  "span",
                  { staticStyle: { width: "65px", "margin-left": "2px" } },
                  [_vm._v("问题描述")]
                ),
                _vm._v(" "),
                _c("el-input", {
                  attrs: {
                    type: "textarea",
                    rows: 3,
                    placeholder:
                      "请输入实物型号、品牌、（实收）数量、商品现状描述、具体破损位置、不符合退换原因、客户姓名地址手机号、承运商、收费价格及原因"
                  },
                  model: {
                    value: _vm.build.description,
                    callback: function($$v) {
                      _vm.$set(_vm.build, "description", $$v)
                    },
                    expression: "build.description"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "box-img" },
              [
                _c("span", [_vm._v("上传图片")]),
                _vm._v(" "),
                _c(
                  "el-upload",
                  {
                    staticClass: "img-upload",
                    attrs: {
                      action: _vm.addImgUrl,
                      headers: _vm.headers,
                      "list-type": "picture-card",
                      "auto-upload": true,
                      limit: 5,
                      "before-upload": _vm.beforeAvatarUpload,
                      "on-success": _vm.successImg,
                      "file-list": _vm.fileList,
                      "on-exceed": _vm.exce
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "file",
                        fn: function(ref) {
                          var file = ref.file
                          return _c("div", {}, [
                            _c("img", {
                              staticClass: "el-upload-list__item-thumbnail",
                              attrs: { src: file.url, alt: "" }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "el-upload-list__item-actions" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "el-upload-list__item-preview",
                                    on: {
                                      click: function($event) {
                                        return _vm.handlePictureCardPreview(
                                          file
                                        )
                                      }
                                    }
                                  },
                                  [_c("i", { staticClass: "el-icon-zoom-in" })]
                                ),
                                _vm._v(" "),
                                !_vm.build.disabled
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "el-upload-list__item-delete",
                                        on: {
                                          click: function($event) {
                                            return _vm.handleRemove(file)
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-delete"
                                        })
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ])
                        }
                      }
                    ])
                  },
                  [
                    _c("i", {
                      staticClass: "el-icon-plus",
                      attrs: { slot: "default" },
                      slot: "default"
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-dialog",
                  {
                    attrs: { visible: _vm.build.dialogVisible },
                    on: {
                      "update:visible": function($event) {
                        return _vm.$set(_vm.build, "dialogVisible", $event)
                      }
                    }
                  },
                  [
                    _c("img", {
                      attrs: {
                        width: "100%",
                        src: _vm.build.dialogImageUrl,
                        alt: ""
                      }
                    })
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "img-info" }, [
              _vm._v("\n        （最多支持上传5张）\n      ")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "box-img" },
              [
                _c("span", [_vm._v("上传视频")]),
                _vm._v(" "),
                _c(
                  "el-upload",
                  {
                    staticClass: "img-upload video-upload",
                    attrs: {
                      action: _vm.addVideoUrl,
                      headers: _vm.headers,
                      "list-type": "picture-card",
                      "auto-upload": true,
                      limit: 3,
                      "before-upload": _vm.beforeAvatarUploadVideo,
                      "on-success": _vm.successVideo,
                      "file-list": _vm.videoList,
                      "on-exceed": _vm.exceVideo
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "file",
                        fn: function(ref) {
                          var file = ref.file
                          return _c("div", {}, [
                            _c(
                              "video",
                              {
                                staticClass: "avatar video-avatar",
                                staticStyle: { width: "100%" },
                                attrs: { src: file.url, controls: "controls" }
                              },
                              [
                                _vm._v(
                                  "\n              您的浏览器不支持视频播放\n            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "el-upload-list__item-video" },
                              [
                                !_vm.build.disabled
                                  ? _c(
                                      "span",
                                      {
                                        on: {
                                          click: function($event) {
                                            return _vm.handleRemoveVideo(file)
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-error",
                                          staticStyle: {
                                            color: "#333",
                                            cursor: "pointer"
                                          }
                                        })
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ])
                        }
                      }
                    ])
                  },
                  [
                    _c("i", {
                      staticClass: "el-icon-plus",
                      attrs: { slot: "default" },
                      slot: "default"
                    })
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "img-info" }, [
              _vm._v("（最多支持上传3个视频）")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "add-margin" },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "button-bg-color",
                    attrs: { type: "primary" },
                    on: { click: _vm.saveAdd }
                  },
                  [_vm._v("提 交")]
                ),
                _vm._v(" "),
                _c("el-button", { on: { click: _vm.closeAdd } }, [
                  _vm._v("取 消")
                ])
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "table-title" }, [
      _c("h6", [_vm._v("查询结果:")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-acd9b2f2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-acd9b2f2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/bigAftersale/aftersale-manage.vue
// module id = null
// module chunks = 